import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export const updateAutomationRuleActorSettingsService = async (input: {
  projectId: string;
  organizationName: string;
  automationRuleId: string;
  actor: 'service-principal' | 'user';
}) => {
	try {
		const httpClient = getHttpClient();
		const response = await httpClient.put(`${apiUrl}/auth/automation-rule-actor-settings/${input.organizationName}/${input.projectId}/${input.automationRuleId}`, {
			actor: input.actor,
		});
  
		if (response.status !== 204) {
			throw new Error('Failed to create automation rule.');
		}
	} catch (error) {
		throw new Error('Failed to update automation rule actor settings.');
	}
};
